import React, { useState, useMemo } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import SublocationKeys from 'src/constants/locale/key/Sublocation'
import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  DataFlattener,
} from 'cng-web-lib'
import makeValidationSchema from './MakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import { NaCustomsOfficeAutocompleteField } from 'src/components/na'
const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngSelectField,
      CngSwitchField
    },
  },
  CngGridItem,
} = components


const DEFAULT_INITIAL_VALUES = Object.freeze({
  intlcode: "",
  active: "",
  language: "",
  indicator: "HBL",
  address: "",
  descriptionEn: "",
  code: "",
  codeMType: "Sublocation" 
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const [indicator, setIndicator] = useState('HBL')
  const lookupProps = useMemo(() => ({
    filters: [
      { field: 'indicator', operator: 'equal', value: indicator || 'HBL' } // fallback if empty
    ]
  }), [indicator]);


  const { translate } = useTranslation(Namespace.SUBLOCATION)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let sublocationCode = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.TITLE
    )
    let intlcode = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.INTLCODE
    )
    let active = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.ACTIVE
    )
    let language = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.LANGUAGE
    )
    let indicator = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.INDICATOR
    )
    let address = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.ADDRESS
    )
    let descriptionEn = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.DESCRIPTION_EN
    )
    let code = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.CODE
    )
  
    
    

    return {
      sublocationCode,
      intlcode,
      active,
      language,
      indicator,
      address,
      descriptionEn,
      code
    }
  }

	return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.sublocationCode} />
      <CardContent>
        <Grid container spacing={3}>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.intlcode}>
            <CngTextField
              name="intlcode"
              label={translatedTextsObject.intlcode + " *"}
              disabled={disabled}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.active}>
            <CngSwitchField
              name='active'
              label={translatedTextsObject.active}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.language}>
            <CngTextField
              name="language"
              label={translatedTextsObject.language + " *"}
            />
          </CngGridItem>
          <Grid item xs={12} sm={6} >
            <CngSelectField
              name='indicator'
              label={translatedTextsObject.indicator + " *"}
              disabled={disabled}
              items={[
                { text: 'ACI', value: 'ACI' },
                { text: 'HBL', value: 'HBL' }              ]}
              onChange={(event) =>
                setIndicator(event.target.value)
              }
              //value={indicator}
            />
          </Grid>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.address}>
            <CngTextField
              name="address"
              label={translatedTextsObject.address}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.descriptionEn}>
            <CngTextField
              name="descriptionEn"
              label={translatedTextsObject.descriptionEn+ " *"}
            />
          </CngGridItem>
          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.code}>
            <NaCustomsOfficeAutocompleteField
              name="code"
              label={translatedTextsObject.code+ " *"}
              disabled={disabled}
              size='small'
              key={indicator}
              lookupProps={lookupProps}
            />
          </CngGridItem>
        </Grid>
      </CardContent>
    </Card>
	)
}

function toClientDataFormat(serverData) {
  let localData = DataFlattener.parse(serverData);
  return localData;
}

function toServerDataFormat(localData) {
  localData.codeMType = "Sublocation"
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
